(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hol-luxury-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const copy = document.querySelector('.hol-cart-copy');

    const enhanceSwatches = (root = document) => {
      root.querySelectorAll('.product-swatch.color-swatch--wide .swatch-variant-color:not([data-hol-swatch-ready])').forEach((swatch) => {
        swatch.dataset.holSwatchReady = 'true';
        const rgb = getComputedStyle(swatch).backgroundColor.match(/[\d.]+/g);
        if (!rgb || rgb.length < 3) return;
        const [r, g, b] = rgb.slice(0, 3).map(Number);
        const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
        swatch.classList.toggle('hol-swatch--light', luminance > .64);
      });
    };

    const compactCollectionHero = () => {
      if (!window.location.pathname.includes('/collections/')) return;
      const heading = document.querySelector('main h1');
      if (!heading) return;

      let candidate = heading.parentElement;
      while (candidate && candidate.tagName !== 'MAIN') {
        if (candidate.getBoundingClientRect().height > 340) {
          candidate.classList.add('hol-compact-collection-hero');
          break;
        }
        candidate = candidate.parentElement;
      }
    };

    const enhanceCart = () => {
      if (!copy) return;
      const portal = document.querySelector('#essential-cart-drawer-portal');
      if (!portal) return;

      const header = portal.querySelector('[data-essential-cart-element="cart-drawer-header"]');
      if (header && !portal.querySelector('.hol-delivery-panel')) {
        const panel = document.createElement('section');
        panel.className = 'hol-delivery-panel';
        panel.setAttribute('aria-label', copy.dataset.title);

        const mark = document.createElement('span');
        mark.className = 'hol-delivery-panel__mark';
        mark.setAttribute('aria-hidden', 'true');
        mark.textContent = 'L';

        const body = document.createElement('div');
        const title = document.createElement('h3');
        title.className = 'hol-delivery-panel__title';
        title.textContent = copy.dataset.title;

        const stock = document.createElement('p');
        stock.className = 'hol-delivery-panel__line';
        stock.textContent = copy.dataset.stock;

        const preorder = document.createElement('p');
        preorder.className = 'hol-delivery-panel__line';
        preorder.textContent = copy.dataset.preorder;

        const meta = document.createElement('p');
        meta.className = 'hol-delivery-panel__meta';
        meta.textContent = `${copy.dataset.tracking} · ${copy.dataset.free}`;

        body.append(title, stock, preorder, meta);
        panel.append(mark, body);
        header.insertAdjacentElement('afterend', panel);
      }

      const walker = document.createTreeWalker(portal, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const match = node.nodeValue.match(/^Spend\s+(.+?)\s+to unlock your reward!$/i);
        if (match) node.nodeValue = `${copy.dataset.progressPrefix} ${match[1]} ${copy.dataset.progressSuffix}`;
      }
    };

    compactCollectionHero();
    enhanceSwatches();
    enhanceCart();
    const observer = new MutationObserver((mutations) => {
      enhanceCart();
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          enhanceSwatches(node);
        }
      }));
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hol-luxury-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hol-product').forEach((section)=>{const variants=JSON.parse(section.querySelector('[data-product-variants]').textContent);const radios=[...section.querySelectorAll('[data-option-value]')];const idInput=section.querySelector('[data-variant-id]');const price=section.querySelector('[data-price]');const compare=section.querySelector('[data-compare-price]');const button=section.querySelector('[data-add-button]');const label=section.querySelector('[data-add-label]');const preorder=section.querySelector('.hol-product__status--preorder');const money=(c)=>new Intl.NumberFormat(document.documentElement.lang||'de-CH',{style:'currency',currency:window.Shopify?.currency?.active||'CHF'}).format(c/100);const update=()=>{const selected=[...section.querySelectorAll('[data-option-value]:checked')].map(input=>input.value);const variant=variants.find(item=>item.options.every((value,index)=>value===selected[index]));if(!variant)return;idInput.value=variant.id;price.textContent=money(variant.price);if(variant.compare_at_price>variant.price){compare.hidden=false;compare.textContent=money(variant.compare_at_price)}else{compare.hidden=true}button.disabled=!variant.available;label.textContent=variant.available?(preorder?'Vorbestellen':'In den Warenkorb'):'Ausverkauft';history.replaceState({},'',`${section.dataset.productUrl}?variant=${variant.id}`)};radios.forEach(input=>input.addEventListener('change',update));const dialog=section.querySelector('[data-size-dialog]');section.querySelector('[data-size-guide]')?.addEventListener('click',()=>dialog.showModal());section.querySelector('[data-size-close]')?.addEventListener('click',()=>dialog.close());dialog?.addEventListener('click',(event)=>{if(event.target===dialog)dialog.close()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["house-of-loren-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hol-product').forEach((section)=>{const colorMap={schwarz:'#111111',black:'#111111',weiss:'#f7f7f4','weiß':'#f7f7f4',white:'#f7f7f4',creme:'#e9e0cf',cream:'#e9e0cf',navy:'#13213a','navy blue':'#13213a','light blue':'#b8d5e8',hellblau:'#b8d5e8'};section.querySelectorAll('[data-hol-color]').forEach((swatch)=>{const value=swatch.dataset.holColor.trim().toLowerCase();if(colorMap[value])swatch.style.setProperty('--hol-swatch-color',colorMap[value])});const variants=JSON.parse(section.querySelector('[data-product-variants]').textContent);const radios=[...section.querySelectorAll('[data-option-value]')];const idInput=section.querySelector('[data-variant-id]');const price=section.querySelector('[data-price]');const compare=section.querySelector('[data-compare-price]');const button=section.querySelector('[data-add-button]');const label=section.querySelector('[data-add-label]');const preorder=section.querySelector('.hol-product__status--preorder');const money=(c)=>new Intl.NumberFormat(document.documentElement.lang||'de-CH',{style:'currency',currency:window.Shopify?.currency?.active||'CHF'}).format(c/100);const update=()=>{const selected=[...section.querySelectorAll('[data-option-value]:checked')].map(input=>input.value);const variant=variants.find(item=>item.options.every((value,index)=>value===selected[index]));if(!variant)return;idInput.value=variant.id;price.textContent=money(variant.price);if(variant.compare_at_price>variant.price){compare.hidden=false;compare.textContent=money(variant.compare_at_price)}else{compare.hidden=true}button.disabled=!variant.available;label.textContent=variant.available?(preorder?'Vorbestellen':'In den Warenkorb'):'Ausverkauft';history.replaceState({},'',`${section.dataset.productUrl}?variant=${variant.id}`)};radios.forEach(input=>input.addEventListener('change',update));const dialog=section.querySelector('[data-size-dialog]');section.querySelector('[data-size-guide]')?.addEventListener('click',()=>dialog.showModal());section.querySelector('[data-size-close]')?.addEventListener('click',()=>dialog.close());dialog?.addEventListener('click',(event)=>{if(event.target===dialog)dialog.close()})});

  } catch(e) { console.error(e); }
})();
})();
